"use client";

import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "@/utils/models/supabase";

export function createClient() {
	// Determina se siamo in ambiente di sviluppo (localhost)
	const isDevelopment =
		typeof window !== "undefined" && window.location.hostname === "localhost";

	return createBrowserClient<Database>(
		process.env.NEXT_PUBLIC_SUPABASE_URL as string,
		process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY as string,
		{
			cookieOptions: {
				// Non impostare domain su localhost
				...(isDevelopment ? {} : { domain: ".originsolutions.it" }),
				path: "/",
				sameSite: "lax",
				secure: true,
			},
		},
	);
}
